import { CEProductBase } from './ce-product-base'


export class CEProduct extends CEProductBase {

}